import { render, staticRenderFns } from "./wxPayQrcode.vue?vue&type=template&id=d53d4c12&scoped=true&"
import script from "./wxPayQrcode.vue?vue&type=script&lang=js&"
export * from "./wxPayQrcode.vue?vue&type=script&lang=js&"
import style0 from "./wxPayQrcode.vue?vue&type=style&index=0&id=d53d4c12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d53d4c12",
  null
  
)

export default component.exports